import { UserBack, UserFront } from './types';

export const userFromBack = (input: UserBack): UserFront =>
  ({
    ...input,
    studyGroup: input.studyGroup,
    resetPasswordExpires: new Date(input.resetPasswordExpires),
    questionnaireResponses: new Map(
      Object.entries(input.questionnaireResponses).map(([questionnaireKey, array]) => [
        questionnaireKey,
        array.map(({ _id, finished }) => ({ _id, finished: finished ? new Date(finished) : false })),
      ]),
    ),
  }) as UserFront;

export const userToBack = (input: UserFront): UserBack => ({
  ...input,
  resetPasswordExpires: input.resetPasswordExpires.toISOString(),
  questionnaireResponses: Object.fromEntries(
    Array.from(input.questionnaireResponses.entries()).map(([questionnaireKey, array]) => [
      questionnaireKey,
      array.map(({ _id, finished }) => ({ _id, finished: finished ? finished.toISOString() : false })),
    ]),
  ),
});
